const insightsGroupTypes = {
  DAY: "DAY",
  WEEK: "WEEK",
};

export const DAY = { DAY: insightsGroupTypes.DAY };
export const WEEK = { WEEK: insightsGroupTypes.WEEK };
